"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnswer = useAnswer;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function useAnswer(questionId) {
    const setAnswer = (0, stores_1.useAnswersStore)((state) => state.setAnswer);
    const answers = (0, stores_1.useAnswersStore)((state) => state.answers);
    return (0, react_1.useMemo)(() => {
        const answer = answers.find((answer) => answer.questionId === questionId);
        return (0, view_models_1.answerViewModel)(answer, setAnswer);
    }, [answers, questionId, setAnswer]);
}
